// extracted by mini-css-extract-plugin
module.exports = {"theme":"style_theme__28m1V","input":"style_input__e3urA","inner":"style_inner__1JzOq","box":"style_box__2iqvd","themeBig":"style_themeBig__1x9US"};